import { AntDesign } from "@expo/vector-icons";
import { classValidatorResolver } from "@hookform/resolvers/class-validator";
import { router } from "expo-router";
import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { View, ScrollView, Pressable } from "react-native";
import { useDispatch } from "react-redux";

import Logo from "@/assets/logo.svg";
import Copyright from "@/components/Copyright";
import Loader from "@/components/Loader";
import ProgressBarComponent from "@/components/ProgressBarComponent";
import Title from "@/components/Title";
import Button from "@/components/button/Button";
import ButtonLogout from "@/components/button/ButtonLogout";
import Input from "@/components/input/Input";
import InputPhone from "@/components/input/InputPhone";
import { setForm } from "@/context/actions/actions";
import { CustomerDetailsCorporationObject } from "@/utils/dto/application.request";

type FormData = {
  websiteAddress: string;
  emailAddress: string;
  telephoneNumber: string;
};

export default function Contact() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const resolver = classValidatorResolver(CustomerDetailsCorporationObject, {
    validator: { skipMissingProperties: true },
  });

  const { control, handleSubmit, formState } = useForm<FormData>({
    mode: "onSubmit",
    resolver,
  });

  const { isSubmitting } = formState;

  const onSubmit = async (data: FormData) => {
    dispatch(
      setForm({
        websiteAddress: data.websiteAddress,
        emailAddress: data.emailAddress,
        telephoneNumber: data.telephoneNumber,
      })
    );
    router.push("/corporation/localization");
  };

  return (
    <ScrollView contentContainerClassName="flex-grow bg-white1">
      <View className="z-50 absolute top-0 right-0 m-8">
        <ButtonLogout />
      </View>
      <View className="items-center justify-center w-full h-full">
        <Logo className="m-2" />
        <View className="m-2">
          <Title text={t("onboarding/corporation/contact:title")} />
        </View>
        <View className="items-center h-fit w-full lg:w-3/5 lg:h-152 lg:border lg:border-solid lg:border-gray lg:rounded-md lg:shadow">
          <Pressable
            onPress={() => {
              router.back();
            }}
            className="absolute z-[60] top-0 left-4 lg:left-6 lg:top-10"
          >
            <AntDesign name="arrowleft" size={24} color="#BDBDBD" />
          </Pressable>
          <View className="w-4/5 items-center mb-1 lg:w-full">
            <ProgressBarComponent progress={0} animatedValue={0.25} />
          </View>
          <View className="z-50 flex-grow justify-center w-full items-center">
            <Input
              label={t("onboarding/corporation/contact:input.websiteAddress")}
              control={control}
              name="websiteAddress"
            />
            <Input
              label={t("onboarding/corporation/contact:input.emailAddress")}
              control={control}
              name="emailAddress"
            />
            <InputPhone
              label={t("onboarding/corporation/contact:input.telephoneNumber")}
              control={control}
              name="telephoneNumber"
            />
          </View>
          <View className="w-full items-center">
            <Button
              label={t("common:button.nextstep")}
              onClick={handleSubmit(onSubmit)}
            />
          </View>
        </View>
        <View className="flex-grow justify-end">
          <Copyright />
        </View>
      </View>
      {isSubmitting && <Loader />}
    </ScrollView>
  );
}
